import { composeRewrites, createRouter, } from '@tanstack/react-router';
import { addLegacyPrefix, addLocale, fromLocalizedUrl, splitLocale, stripUniversalPrefix, toLocalizedUrl, } from '@tymia/main-api';
import { wait, } from '@tymia/shared';
import { once, } from 'remeda';
import { configStore, } from '../common/config/ConfigStore.js';
import { routeTree, } from './routeTree.gen.js';
import { searchParser, } from './searchParser.js';
export const router = once(() => {
    let localeInProcess = undefined;
    const legacyPrefixRewrite = {
        input: ({ url }) => {
            // Browser URL -> internal TanStack URL
            //
            // /2/suche/foo -> /suche/foo
            // /suche/foo   -> /suche/foo
            url = stripUniversalPrefix(url);
            return url;
        },
        output: ({ url }) => {
            return addLegacyPrefix(url);
        },
    };
    const localeRewrite = {
        input: ({ url }) => {
            const { pathname, locale } = splitLocale(url.pathname);
            localeInProcess = locale;
            url.pathname = pathname;
            return url;
        },
        output: ({ url }) => {
            const config = configStore.get();
            if (config.state !== 'initialized') {
                throw new Error('Config not initialized');
            }
            return addLocale(config.principal.locale.toLocaleLowerCase(), url);
        },
    };
    const translatedPathRewrite = {
        input: ({ url }) => {
            const config = configStore.get();
            if (config.state !== 'initialized') {
                throw new Error('Config not initialized');
            }
            return fromLocalizedUrl(url, localeInProcess);
        },
        output: ({ url }) => {
            const config = configStore.get();
            if (config.state !== 'initialized') {
                throw new Error('Config not initialized');
            }
            return toLocalizedUrl(url, config.principal.locale);
        },
    };
    return createRouter({
        routeTree,
        search: {
            // respect value returned from validateSearch
            strict: true,
        },
        scrollRestoration: true,
        // otherwise stale result is presented if the user
        // navigates to the same route again
        defaultGcTime: 0,
        rewrite: composeRewrites([
            legacyPrefixRewrite,
            localeRewrite,
            translatedPathRewrite,
        ]),
        stringifySearch: searchParser.stringifySearch,
        parseSearch: searchParser.parseSearch,
    });
});
// generated with ChatGPT
export async function waitForRouterSettled(currentRouter, timeoutMs = 3_000) {
    function isSettled() {
        return currentRouter.state.status === 'idle'
            && currentRouter.state.resolvedLocation !== undefined;
    }
    if (isSettled()) {
        return true;
    }
    let unsubscribe = () => { };
    const resolved = new Promise(resolve => {
        unsubscribe = currentRouter.subscribe('onResolved', () => {
            resolve(true);
        });
        // Catch resolution between the first check and subscribe().
        if (isSettled()) {
            resolve(true);
        }
    });
    try {
        return await Promise.race([
            resolved,
            wait(timeoutMs).then(() => false),
        ]);
    }
    finally {
        unsubscribe();
    }
}
//# sourceMappingURL=router.js.map